<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      app
      light
      disable-resize-watcher
      hide-overlay
      height="250px"
      class="grey lighten-4"

    >
      <v-list>
        <v-list-item
          v-for="item in menu_drawer"
          :key="item.text"
          :to="item.to"
          link
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div>
          <v-btn
            outlined
            block
            class="hidden-sm-and-down ma-2"
            to="/login"
            v-if="username == '' || username == null"
            >Login</v-btn>
          <v-btn
            block
            color="primary" elevation="4"
            class="hidden-sm-and-down"
            to="/get-started"
            >Free Trial</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Announcement banner on top -->
    <v-system-bar
      height="30"
      color="#00989E"
      v-if="top"
    >
      <marquee class="white--text" onmouseover="this.stop();" onmouseout="this.start();">
        <span class="font-weight-bold">
          Announce: Discover our Offensive Security-as-a-Service Platform on <a href="https://patrowl.io" color="white">patrowl.io</a> // Be faster than attackers
        </span>
      </marquee>
    </v-system-bar>

    <v-app-bar
      app
      clipped-left
      elevate-on-scroll
      scroll-threshold="500"
      :class='top == true?"mt-7":""'
    >
      <!-- -->
      <v-app-bar-nav-icon @click="drawer = !drawer" class="hidden-md-and-up"/>
      <!-- <v-img :src="images.logo" style="cursor: pointer;" max-width="140" @click="routeTo('#section-hero-hears', '/')"></v-img> -->
      <v-img :src="images.logo" style="cursor: pointer;" max-width="140" @click="routeTo('#section-hero-hears', '/')"></v-img>
      <v-spacer />
      <v-spacer class="hidden-md-and-up"></v-spacer>

      <!-- Company Menu -->
      <!-- <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="hidden-sm-and-down"
            @click="routeTo('#section-company', '/home')"
          >Company<v-icon small>mdi-chevron-down</v-icon></v-btn>
        </template>
        <v-list v-if='this.$route.path == "/home"'>
          <v-list-item
            v-for="(item, index) in menu_company"
            :key="index"
            @click="$router.push(item.to)"
          ><v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list v-else>
          <v-list-item
            v-for="(item, index) in menu_company"
            :key="index"
            @click="routeTo('#section-company', '/home')"
          ><v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <!-- Products Menu -->
      <!-- <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="hidden-sm-and-down"
            @click="routeTo('#section-products', '/home')"
          >Products<v-icon small>mdi-chevron-down</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in menu_products"
            :key="index"
            @click="$router.push(item.to)"
          ><v-list-item-title v-if="item.text != 'Patrowl'">{{ item.text }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.text }} <v-icon small color="primary">mdi-alert-decagram</v-icon></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <!-- Pricing Menu -->
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="hidden-sm-and-down"
            @click="routeTo('#section-hears-summary', '/#section-hears-summary')"
          >Vulnerability Intelligence</v-btn>
        </template>
      </v-menu>

      <!-- Pricing Menu -->
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="hidden-sm-and-down"
            @click="routeTo('#pricing', '/#pricing')"
          >Pricing</v-btn>
        </template>
        <!-- <v-list v-if='this.$route.path == "/home"'> -->
        <!-- <v-list>
          <v-list-item
            v-for="(item, index) in menu_products"
            :key="index"
            @click="$router.push(item.to)"
          ><v-list-item-title v-if="item.text != 'Patrowl'">{{ item.text }}</v-list-item-title>
            <v-list-item-title v-else>{{ item.text }} <v-icon small color="primary">mdi-alert-decagram</v-icon></v-list-item-title>
          </v-list-item>
        </v-list> -->
        <!-- <v-list v-else>
          <v-list-item
            v-for="(item, index) in menu_products"
            :key="index"
            @click="routeTo('#section-entreprise', '/home')"
          >
          <v-list-item-title v-if="item.text != 'PatrowlDashboard'">{{ item.text }}</v-list-item-title>
          <v-list-item-title v-else>{{ item.text }} <v-icon small color="primary">mdi-alert-decagram</v-icon></v-list-item-title>
          </v-list-item>
        </v-list> -->
      </v-menu>

      <!-- Resources Menu -->
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
            class="hidden-sm-and-down"
          >Resources<v-icon small>mdi-chevron-down</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in menu_resources"
            :key="index"
            :to="item.to"
            :href="item.href"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-divider
        class="hidden-sm-and-down mx-4"
        vertical
        inset
      ></v-divider>
      <v-btn
        outlined
        class="hidden-sm-and-down ma-2"
        to="/login"
        v-if="username == '' || username == null"
        >Login</v-btn>
      <v-btn
        outlined
        class="hidden-sm-and-down ma-2"
        to="/portal/home"
        v-if="username != '' && username != null"
        >Account</v-btn>
      <v-btn
        raised
        color="primary"
        elevation="4"
        class="hidden-sm-and-down"
        to="/get-started"
        >Free Trial</v-btn>
   </v-app-bar>

    <!-- Sizes your content based upon application components -->
   <v-main>
     <v-container fluid pa-0>
       <router-view></router-view>
     </v-container>
   </v-main>

   <public-app-layout-footer></public-app-layout-footer>

  </v-app>
</template>

<script>
import PublicAppLayoutFooter from '@/components/layouts/PublicAppLayoutFooter';

export default {
  name: 'PublicAppLayout',
  components: {
    PublicAppLayoutFooter
  },
  metaInfo: {
    title: 'PatrowlHears.io - Vulnerability Intelligence Center',
    meta: [
      {name: 'keywords', content: 'Patrowl, SecOps, Vulnerability Management, CVE, CPE, CWE, Threat Intelligence, Penetration testing, Exploit, PoC, Scoring, Rating, Cyber-Rating, Cyber-Scoring'},
      {name: 'description', content: 'PatrowlHears.io - SecOps and Threats Management Center. Automate your SecOps with PatrOwl, and start defending your assets efficiently'},
      // OpenGraph data (Most widely used)
      {property: 'og:title', content: 'PatrowlHears.io'},
      {property: 'og:site_name', content: 'PatrowlHears.io'},
      {property: 'og:type', content: 'website'},
      {property: 'og:url', content: 'https://patrowlhears.io'},
      {property: 'og:image', content: 'https://patrowl.io/static/img/logo-patrowl-dark.282bdf1d.png'},
      // Often the same as your meta description, but not always.
      {property: 'og:description', content: 'PatrowlHears.io - SecOps and Threats Management Center. Automate your SecOps with PatrOwl, and start defending your assets efficiently'},

      // Twitter card
      {name: 'twitter:card', content: 'PatrowlHears.io - Vulnerability Intelligence Center'},
      {name: 'twitter:site', content: 'https://patrowlhears.io'},
      {name: 'twitter:title', content: 'PatrowlHears.io - Vulnerability Intelligence Center'},
      {name: 'twitter:description', content: 'PatrowlHears.io - Real-time vulnerability and threat intelligence platform, on steroids.'},
      // Your twitter handle, if you have one.
      {name: 'twitter:creator', content: '@patrowl_io'},
      {name: 'twitter:image:src', content: 'https://patrowl.io/static/img/logo-patrowl-dark.282bdf1d.png'},

      // Google / Schema.org markup:
      {itemprop: 'name', content: 'PatrowlHears.io - Vulnerability Intelligence Center'},
      {itemprop: 'description', content: 'PatrowlHears.io - Real-time vulnerability and threat intelligence platform, on steroids.'},
      {itemprop: 'image', content: 'https://patrowl.io/static/img/logo-patrowl-dark.282bdf1d.png'},

      {name: 'robots', content: 'index,follow'},
    ]
  },
  data: () => ({
    top: true,
    username: '',
    drawer: false,
    images: {
      // logo: require('@/assets/img/logo-patrowl-dark.png'),
      // logo: require('@/assets/img/logo-patrowl-black.png'),
      logo: require('@/assets/img/patrowlhears-logo-orange.png'),
      // logo: require('@/assets/img/logohears2.png'),
    },
    menu_drawer: [
      { text: 'Home', to: '/' },
      { text: 'Company', to: '/home' },
      { text: 'Products', to: '/products/patrowl' },
      // { text: 'Resources', to: '/get-started' },
      { text: 'Login', to: '/login' },
      { text: 'Free Trial', to: '/get-started' },
    ],
    menu_company: [
      // { text: 'PatrowlManager - Free', to: '/home#section-products' },
      { text: 'Our values', to: '/home' },
      { text: 'About us', to: '/about-us' },
      { text: 'Contact', to: '/about-us#section-about-contacts' },
    ],
    // menu_usecases: [
    //   { text: 'Vulnerability Management', to: '/home#section-usecases' },
    //   { text: 'Cyber-Exposure Monitoring', to: '/home#section-usecases' },
    //   { text: 'Penetration Testing', to: '/home#section-usecases' },
    //   { text: 'Security Operations Center & CTI', to: '/home#section-usecases' },
    //   { text: 'DevSecOps', to: '/home#section-usecases' },
    //   { text: 'Vulnerability Alerting & Prioritization', to: '/home#section-usecases' },
    //   { text: 'Compliance & Benchmarks', to: '/home#section-usecases' },
    // ],
    // menu_services: [
    //   { text: 'Profesional Support', to: '/services#support' },
    //   { text: 'Managed Services', to: '/services#support' },
    //   { text: 'Integration', to: '/services#integration' },
    //   { text: 'Custom developments', to: '/services#dev' },
    //   { text: 'Trainings', to: '/services#trainings' },
    //   { text: 'Consulting', to: '/services#consulting' }
    // ],
    menu_products: [
      { text: 'Patrowl', href: 'https://patrowl.io' },
      { text: 'PatrowlHears', to: '/' },
      // { text: 'PatrowlManager', to: '/products/manager' },
    ],
    // menu_usecases: [
    //   { text: 'Vulnerability Management', to: '/home#section-usecases' },
    //   { text: 'Cyber-Exposure Monitoring', to: '/home#section-usecases' },
    //   { text: 'Penetration Testing', to: '/home#section-usecases' },
    //   { text: 'Security Operations Center & CTI', to: '/home#section-usecases' },
    //   { text: 'DevSecOps', to: '/home#section-usecases' },
    //   { text: 'Vulnerability Alerting & Prioritization', to: '/home#section-usecases' },
    //   { text: 'Compliance & Benchmarks', to: '/home#section-usecases' },
    // ],
    // menu_services: [
    //   { text: 'Profesional Support', to: '/services#support' },
    //   { text: 'Managed Services', to: '/services#support' },
    //   { text: 'Integration', to: '/services#integration' },
    //   { text: 'Custom developments', to: '/services#dev' },
    //   { text: 'Trainings', to: '/services#trainings' },
    //   { text: 'Consulting', to: '/services#consulting' }
    // ],
    menu_resources: [
      { text: 'Get Started', to: '/get-started' },
      { text: 'About us', to: '/about-us' },
      { text: 'Contact', to: '/about-us#section-about-contacts' },
      { text: 'Legal', to: '/legal' },
      { text: 'Offensive Security', href: 'https://patrowl.io' },
      // { text: 'Careers', to: '/about-us#section-about-contacts' },
      // { text: 'Events & News', to: '/about-us#section-about-contacts' },
    ],
    is_on_top: true,
  }),
  created() {
    document.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.handleScroll();
    this.getUsername();

    var lastScrollTop = 0;
    var vm = this;

    window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
     var st = window.pageYOffset || document.documentElement.scrollTop;
     lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
     vm.top = lastScrollTop <= 5 ? true : false
   }, false);
  },
  methods: {
    handleScroll() {
      if (this.$route.name == 'LandingPatrowlHears') {
        this.is_on_top=false
      } else {
        this.is_on_top=window.pageYOffset==0
      }

    },
    getUsername() {
      this.username = localStorage.getItem('username');
      return this.username;
    },
    routeTo(hometo, to) {
      if (this.$route.path == "/") {
        this.$vuetify.goTo(hometo);
      } else {
        this.$router.push(to);
      }
    },
  },
}
</script>
